var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-layout-chooser',{attrs:{"default-layouts":_vm.defaultLayouts,"loading":_vm.isLoading,"apps":_vm.showMobileAppsOption,"selected-app":_vm.selectedAppForLayoutChooser,"use-app-display":true},on:{"select-layout":_vm.chooseLayout,"select-app":_vm.chooseApp,"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }